import { render, staticRenderFns } from "./ContactUsLayout.vue?vue&type=template&id=2a783e5c&"
var script = {}
import style0 from "./ContactUsLayout.vue?vue&type=style&index=0&id=2a783e5c&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopContent: require('/opt/atlassian/pipelines/agent/build/components/TopContent.vue').default,Navbar: require('/opt/atlassian/pipelines/agent/build/components/Navbar.vue').default,CookieBanner: require('/opt/atlassian/pipelines/agent/build/components/CookieBanner.vue').default,FooterContactUs: require('/opt/atlassian/pipelines/agent/build/components/FooterContactUs.vue').default})
